import { render } from "./PendingInstallations.vue?vue&type=template&id=40d661d7"
import script from "./PendingInstallations.vue?vue&type=script&lang=js"
export * from "./PendingInstallations.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__